export const songList = [
  // one more try
  {
    id: "14",
    title: "एक और ट्राय",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Hindi_Version_2/ek-or-bar-hindi.mp3",
    language: "Hindi",
  },
  {
    id: "15",
    title: "ఇంకో ప్రయత్నం",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Telugu/telgu.mp3",
    language: "Telugu",
  },
  {
    id: "16",
    title: "再试一次",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Chinese/mandarin.mp3",
    language: "Chinese",
  },
  {
    id: "17",
    title: "Un intento más",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Spanish/spanish.mp3",
    language: "Spanish",
  },
  {
    id: "18",
    title: "محاولة أخرى",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Arabic/arabic.mp3",
    language: "Arabic",
  },
  {
    id: "19",
    title: "One More Try",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/English/one+more+try_english.mp3",
    language: "English",
  },
  {
    id: "22",
    title: "もう一度試す",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Japanese/One+More+Try_Japanese.mp3",
    language: "Japanese",
  },
  {
    id: "23",
    title: "Un altro tentativo",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/One+more+try_Italian.mp3",
    language: "Italian",
  },
  {
    id: "24",
    title: "Une autre tentative",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/One+more+try_French.mp3",
    language: "French",
  },
  {
    id: "25",
    title: "Noch ein Versuch",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/One+more+try_German.mp3",
    language: "German",
  },
  {
    id: "72",
    title: "Ещё одна попытка",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_russian.mp3",
    language: "Russian",
  },
  {
    id: "73",
    title: "Mais uma tentativa",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_portuguese.mp3",
    language: "Portuguese",
  },
  {
    id: "74",
    title: "Bir Şans Daha",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Turkish.mp3",
    language: "Turkish",
  },
  {
    id: "75",
    title: "한 번 더",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_korean.mp3",
    language: "Korean",
  },
  {
    id: "76",
    title: "आणखी एक प्रयत्न",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Marathi.mp3",
    language: "Marathi",
  },
  {
    id: "77",
    title: "એક વધુ પ્રયાસ",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Gujrathi.mp3",
    language: "Gujarati",
  },
  {
    id: "78",
    title: "இன்னொரு முயற்சி",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Gujrathi.mp3",
    language: "Tamil",
  },
  // Welcome to our town
  {
    id: "32",
    title: "Welcome to our town",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome+to+our+town+-english+version.MP3",
    language: "English",
  },
  {
    id: "33",
    title: "हमारे शहर में आपका स्वागत है",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_hindi%20version.mp3",
    language: "Hindi",
  },
  {
    id: "34",
    title: "مرحبًا بكم في مدينتنا",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_arabic%20version.mp3",
    language: "Arabic",
  },
  {
    id: "35",
    title: "欢迎来到我们的城镇",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_chinese%20version.mp3",
    language: "Chinese",
  },
  {
    id: "36",
    title: "Bienvenue dans notre ville",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_french%20version.mp3",
    language: "French",
  },
  {
    id: "37",
    title: "Willkommen in unserer Stadt",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_german%20version.mp3",
    language: "German",
  },
  {
    id: "38",
    title: "Benvenuto nella nostra città",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_italian%20version.mp3",
    language: "Italian",
  },
  {
    id: "39",
    title: "私たちの町へようこそ",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_japanese%20version.mp3",
    language: "Japanese",
  },
  {
    id: "40",
    title: "Bienvenido a nuestro pueblo",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_spanish%20version.mp3",
    language: "Spanish",
  },
  {
    id: "41",
    title: "మా పట్టణానికి స్వాగతం",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Welcome%20to%20our%20town_telugu%20version.mp3",
    language: "Telugu",
  },
    {
  id: "93",
  title: "અમારા શહેરમાં આપનું સ્વાગત છે.",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Welcome_to_our_town_Updated/Welcome%20to%20our%20town%20Gujrati-%E0%AA%86%E0%AA%AA%E0%AA%A3%E0%AA%BE%20%E0%AA%97%E0%AA%BE%E0%AA%AE%E0%AB%87%20%E0%AA%86%E0%AA%B5%E0%AB%8B%20%E0%AA%B8%E0%AB%8C.mp3",
  language: "Gujarati",
  },
  {
  id: "94",
  title: "우리 마을에 오신 것을 환영합니다",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Welcome_to_our_town_Updated/Welcome%20to%20our%20town%20korean%20-Uri%20Maeure%20Oseyo.mp3",
  language: "Korean",
  },
  {
  id: "95",
  title: "आमच्या शहरात आपले स्वागत आहे",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Welcome_to_our_town_Updated/Welcome%20to%20our%20town%20marathi-%E0%A4%86%E0%A4%AE%E0%A4%9A%E0%A5%8D%E0%A4%AF%E0%A4%BE%20%E0%A4%97%E0%A4%BE%E0%A4%B5%E0%A5%80%20%E0%A4%AF%E0%A4%BE%20%E0%A4%9A%E0%A4%BC%E0%A4%B2%E0%A4%BE.mp3",
  language: "Marathi",
  },
  {
  id: "96",
  title: "Bem-vindo à nossa cidade",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Welcome_to_our_town_Updated/Welcome%20to%20our%20town%20%20PORTUGUESE%20-Bem-vindos%20ao%20nosso%20lugar.mp3",
  language: "Portuguese",
  },
  {
  id: "97",
  title: "Добро пожаловать в наш город",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Welcome_to_our_town_Updated/Welcome%20to%20our%20town%20Russian%20-%20%D0%94%D0%BE%D0%B1%D1%80%D0%BE%20%D0%BF%D0%BE%D0%B6%D0%B0%D0%BB%D0%BE%D0%B2%D0%B0%D1%82%D1%8C%20%D0%BA%20%D0%BD%D0%B0%D0%BC_2.mp3",
  language: "Russian",
  },
  {
  id: "98",
  title: "எங்கள் ஊருக்கு உங்களை வரவேற்கிறோம்",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Welcome_to_our_town_Updated/Welcome%20to%20our%20town%20Tamil-%E0%AE%8E%E0%AE%99%E0%AF%8D%E0%AE%95%E0%AE%B3%E0%AF%8D%20%E0%AE%8A%E0%AE%B0%E0%AF%81%E0%AE%95%E0%AF%8D%E0%AE%95%E0%AF%81%20%E0%AE%B5%E0%AE%B0%E0%AF%81%E0%AE%99%E0%AF%8D%E0%AE%95%E0%AE%B3%E0%AF%8D.mp3",
  language: "Tamil",
  },
  {
  id: "99",
  title: "Kasabamıza hoş geldiniz",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Welcome_to_our_town_Updated/Welcome%20to%20our%20town%20Turkish-%20Kasabam%C4%B1za%20ho%C5%9F%20geldin.mp3",
  language: "Turkish",
  },

  // max
  {
    id: "1",
    title: "एक दिन",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Hindi/Max_Hindi.mp3",
    language: "Hindi",
  },
  {
    id: "2",
    title: "ఒక రోజు",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Telugu/Max_Telgu.mp3",
    language: "Telugu",
  },
  {
    id: "3",
    title: "ある日",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Japanese/Max_Japanese.mp3",
    language: "Japanese",
  },
  {
    id: "4",
    title: "Un día",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Spanish/Max_Spanish.mp3",
    language: "Spanish",
  },
  {
    id: "5",
    title: "يومًا ما",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Arabic/Max_Arabic.mp3",
    language: "Arabic",
  },
  {
    id: "6",
    title: "有一天",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Chinese/Max_Mandarin.mp3",
    language: "Chinese",
  },
  {
    id: "20",
    title: "One day",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/English/max_english.mp3",
    language: "English",
  },
  {
    id: "26",
    title: "Un giorno",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Max_Italian.mp3",
    language: "Italian",
  },
  {
    id: "27",
    title: "Un jour",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Max_French.mp3",
    language: "French",
  },
  {
    id: "28",
    title: "Eines Tages",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Max_song/Max_German.mp3",
    language: "German",
  },
  {
  id: "79",
  title: "એક દિવસ",
  url: "https://f003.backblazeb2.com/file/kingdom-games/One_Day/One+Day+Gujarati-+%E0%AA%8F%E0%AA%95+%E0%AA%A6%E0%AA%BF%E0%AA%B5%E0%AA%B8.mp3",
  language: "Gujarati",
  },
  {
  id: "80",
  title: "어느 날",
  url: "https://f003.backblazeb2.com/file/kingdom-games/One_Day/One%20Day%20Korean%20-%20%EC%96%B8%EC%A0%A0%EA%B0%80.mp3",
  language: "Korean",
  },
  {
  id: "81",
  title: "एक दिवस",
  url: "https://f003.backblazeb2.com/file/kingdom-games/One_Day/One%20Day%20Marathi%20-%E0%A4%8F%E0%A4%95%20%E0%A4%A6%E0%A4%BF%E0%A4%B5%E0%A4%B8.mp3",
  language: "Marathi",
  },
  {
  id: "82",
  title: "Um dia",
  url: "https://f003.backblazeb2.com/file/kingdom-games/One_Day/One%20Day%20Portuguese%20-Um%20Dia.mp3",
  language: "Portuguese",
  },
  {
  id: "83",
  title: "Один день",
  url: "https://f003.backblazeb2.com/file/kingdom-games/One_Day/One%20Day%20Russian%20-%D0%9E%D0%B4%D0%BD%D0%B0%D0%B6%D0%B4%D1%8B.mp3",
  language: "Russian",
  },
  {
    id: "84",
    title: "ஒரு நாள்",
    url: "https://f003.backblazeb2.com/file/kingdom-games/One_Day/One%20Day%20Tamil%20-%E0%AE%92%E0%AE%B0%E0%AF%81%20%E0%AE%A8%E0%AE%BE%E0%AE%B3%E0%AF%8D.mp3",
    language: "Tamil",
  },
  {
  id: "85",
  title: "Bir gün",
  url: "https://f003.backblazeb2.com/file/kingdom-games/One_Day/One%20Day%20Turkish%20-Bir%20G%C3%BCn.mp3",
  language: "Turkish",
  },
  // princess
  {
    id: "7",
    title: "मेरे लिए एक सपना",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Hindi/Princess_Female_Hindi.mp3",
    language: "Hindi",
  },
  {
    id: "8",
    title: "నా కోసం ఒక కల",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Telugu/Princess_Female_Telgu.mp3",
    language: "Telugu",
  },
  {
    id: "9",
    title: "属于我的一个梦想",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Chinese/Princess_Female_Mandarin.mp3",
    language: "Chinese",
  },
  {
    id: "10",
    title: "Un sueño para mí",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Spanish/Princess_Female_Spanish.mp3",
    language: "Spanish",
  },
  {
    id: "11",
    title: "حلم لي",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Arabic/Princess_Female_Arebic.mp3",
    language: "Arabic",
  },
  {
    id: "12",
    title: "私のための夢",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Japanese/Princess_Female_Japanese.mp3",
    language: "Japanese",
  },
  {
  id: "86",
  title: "મારા માટે એક સ્વપ્ન",
  url: "https://f003.backblazeb2.com/file/kingdom-games/A_Dream_for_me/A%20Dream%20for%20me%20%20Gujarati%20%20-%E0%AA%AE%E0%AA%A8%E0%AB%87%20%E0%AA%B9%E0%AB%81%E0%AA%82%20%E0%AA%AC%E0%AA%A8%E0%AA%B5%E0%AA%BE%20%E0%AA%A6%E0%AB%8B.mp3",
  language: "Gujarati",
  },
  {
  id: "87",
  title: "나를 위한 꿈",
  url: "https://f003.backblazeb2.com/file/kingdom-games/A_Dream_for_me/A%20Dream%20for%20me%20%20Korean%20%20%20-%20%EB%82%B4%EA%B0%80%20%EB%90%A0%20%EC%82%AC%EB%9E%8C.mp3",
  language: "Korean",
  },
  {
  id: "88",
  title: "माझ्यासाठी एक स्वप्न",
  url: "https://f003.backblazeb2.com/file/kingdom-games/A_Dream_for_me/A%20Dream%20for%20me%20Marathi%20%20-%20%E0%A4%AE%E0%A4%BE%E0%A4%9D%E0%A5%8D%E0%A4%AF%E0%A4%BE%20%E0%A4%AE%E0%A4%A8%E0%A4%BE%E0%A4%A4%E0%A4%B2%E0%A4%82%20%E0%A4%B8%E0%A5%8D%E0%A4%B5%E0%A4%AA%E0%A5%8D%E0%A4%A8.mp3",
  language: "Marathi",
  },
  {
  id: "89",
  title: "Um sonho para mim",
  url: "https://f003.backblazeb2.com/file/kingdom-games/A_Dream_for_me/A%20Dream%20for%20me%20%20PORTUGUESE%20%20-%20Quem%20Eu%20Posso%20Ser.mp3",
  language: "Portuguese",
  },
  {
  id: "90",
  title: "Мечта для меня",
  url: "https://f003.backblazeb2.com/file/kingdom-games/A_Dream_for_me/A%20Dream%20for%20me%20russian%20%20-%20%D0%9A%D0%B5%D0%BC%20%D0%AF%20%D0%9C%D0%BE%D0%B3%D1%83%20%D0%A1%D1%82%D0%B0%D1%82%D1%8C.mp3",
  language: "Russian",
  },
  {
  id: "91",
  title: "எனக்கான ஒரு கனவு",
  url: "https://f003.backblazeb2.com/file/kingdom-games/A_Dream_for_me/A%20Dream%20for%20me%20Tamil%20%20-%E0%AE%A8%E0%AE%BE%E0%AE%A9%E0%AF%8D%20%E0%AE%86%E0%AE%95%E0%AE%AA%E0%AF%8D%20%E0%AE%AA%E0%AE%BF%E0%AE%B1%E0%AE%A8%E0%AF%8D%E0%AE%A4%E0%AE%B5%E0%AE%A9%E0%AF%8D.mp3",
  language: "Tamil",
  },
  {
  id: "92",
  title: "Benim için bir hayal",
  url: "https://f003.backblazeb2.com/file/kingdom-games/A_Dream_for_me/A%20Dream%20for%20me%20Turkish%20%20-Olabilece%C4%9Fim%20Ki%C5%9Fi.mp3",
  language: "Turkish",
  },
  // {
  //   id: "13",
  //   title: "One More Try (Version 1)",
  //   url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Hindi_Version_1/One+more+try+-+Hindi+V1.mp3",
  //   language: "Hindi",
  // },
  {
    id: "21",
    title: "A Dream for Me",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/English/Princess_english.mp3",
    language: "English",
  },
  {
    id: "29",
    title: "Un sogno per me",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Princess_Italian.mp3",
    language: "Italian",
  },
  {
    id: "30",
    title: "Un rêve pour moi",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Princess_French.mp3",
    language: "French",
  },
  {
    id: "31",
    title: "Ein Traum für mich",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Princes_song/Princess_German.mp3",
    language: "German",
  },
  // we are family
  {
    id: "42",
    title: "We Are Family",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We+are+a+family_english+version.MP3",
    language: "English",
  },
  {
    id: "43",
    title: "हम परिवार हैं",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_hindi%20version.mp3",
    language: "Hindi",
  },
  {
    id: "44",
    title: "نحن عائلة",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_arabic%20version.mp3",
    language: "Arabic",
  },
  {
    id: "45",
    title: "我们是一家人",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_chinese%20version.mp3",
    language: "Chinese",
  },
  {
    id: "46",
    title: "Nous sommes une famille",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_french%20version.mp3",
    language: "French",
  },
  {
    id: "47",
    title: "Wir sind Familie",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_german%20version.mp3",
    language: "German",
  },
  {
    id: "48",
    title: "Siamo famiglia",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_italian%20version.mp3",
    language: "Italian",
  },
  {
    id: "49",
    title: "私たちは家族です",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_japanese%20version.mp3",
    language: "Japanese",
  },
  {
    id: "50",
    title: "Somos familia",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_spanish%20version.mp3",
    language: "Spanish",
  },
  {
    id: "51",
    title: "మనం కుటుంబం",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/We%20are%20a%20family_telgu%20version.mp3",
    language: "Telugu",
  },
    {
  id: "100",
  title: "અમે પરિવાર છીએ",
  url: "https://f003.backblazeb2.com/file/kingdom-games/We_are_Family/We%20are%20Family/We%20are%20family%20Gujarati-%20%E0%AA%85%E0%AA%AE%E0%AB%87%20%E0%AA%8F%E0%AA%95%20%E0%AA%AA%E0%AA%B0%E0%AA%BF%E0%AA%B5%E0%AA%BE%E0%AA%B0.mp3",
  language: "Gujarati",
  },
  {
  id: "101",
  title: "우리는 가족입니다",
  url: "https://f003.backblazeb2.com/file/kingdom-games/We_are_Family/We%20are%20Family/We%20are%20family%20Korean%20-%20%EC%9A%B0%EB%A6%AC%EB%8A%94%20%EA%B0%80%EC%A1%B1.mp3",
  language: "Korean",
  },
  {
  id: "102",
  title: "आम्ही एक कुटुंब आहोत",
  url: "https://f003.backblazeb2.com/file/kingdom-games/We_are_Family/We%20are%20Family/We%20are%20family%20Marathi%20-%20%E0%A4%86%E0%A4%AE%E0%A5%8D%E0%A4%B9%E0%A5%80%20%E0%A4%8F%E0%A4%95%20%E0%A4%AA%E0%A4%B0%E0%A4%BF%E0%A4%B5%E0%A4%BE%E0%A4%B0.mp3",
  language: "Marathi",
  },
  {
  id: "103",
  title: "Nós somos uma família",
  url: "https://f003.backblazeb2.com/file/kingdom-games/We_are_Family/We%20are%20Family/We%20are%20family%20Portuguese%20-%20Somos%20Uma%20Fam%C3%ADlia.mp3",
  language: "Portuguese",
  },
  {
  id: "104",
  title: "Мы — семья",
  url: "https://f003.backblazeb2.com/file/kingdom-games/We_are_Family/We%20are%20Family/We%20are%20family%20Russian%20-%20%D0%9C%D1%8B%20%E2%80%94%20%D0%9E%D0%B4%D0%BD%D0%B0%20%D0%A1%D0%B5%D0%BC%D1%8C%D1%8F.mp3",
  language: "Russian",
  },
  {
  id: "105",
  title: "நாங்கள் ஒரு குடும்பம்",
  url: "https://f003.backblazeb2.com/file/kingdom-games/We_are_Family/We%20are%20Family/We%20are%20family%20Tamil%20-%20%E0%AE%A8%E0%AE%BE%E0%AE%AE%E0%AF%8D%20%E0%AE%92%E0%AE%B0%E0%AF%81%20%E0%AE%95%E0%AF%81%E0%AE%9F%E0%AF%81%E0%AE%AE%E0%AF%8D%E0%AE%AA%E0%AE%AE%E0%AF%8D.mp3",
  language: "Tamil",
  },
  {
  id: "106",
  title: "Biz bir aileyiz",
  url: "https://f003.backblazeb2.com/file/kingdom-games/We_are_Family/We%20are%20Family/We%20are%20family%20Turkish-%20Biz%20Bir%20Aileyiz.mp3",
  language: "Turkish",
  },
  //please stay
  {
    id: "62",
    title: "Please Stay",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20Stay%20English.MP3",
    language: "English",
  },
  {
    id: "63",
    title: "रुक जा",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20Stay%20Hindi.mp3",
    language: "Hindi",
  },
  {
    id: "64",
    title: "من فضلك ابقَ",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20Stay%20Arabic.mp3",
    language: "Arabic",
  },
  {
    id: "65",
    title: "请留下",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20stay%20%20Chinese.mp3",
    language: "Chinese",
  },
  {
    id: "66",
    title: "S’il vous plaît restez",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20stay%20French.mp3",
    language: "French",
  },
  {
    id: "67",
    title: "Bitte bleib",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20stay%20German.mp3",
    language: "German",
  },
  {
    id: "68",
    title: "Per favore resta",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20stay%20%20Italian.mp3",
    language: "Italian",
  },
  {
    id: "69",
    title: "どうかいてください",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20stay%20Japanese.mp3",
    language: "Japanese",
  },
  {
    id: "70",
    title: "Por favor quédate",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20stay%20Spanish.mp3",
    language: "Spanish",
  },
  {
    id: "71",
    title: "దయచేసి ఉండండి",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/Please-Stay/Please%20Stay%20Telugu.mp3",
    language: "Telugu",
  },
    {
  id: "107",
  title: "કૃપા કરીને રોકાઈ જાઓ",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Please_Stayy/please%20stay%20gujrati-%20%E0%AA%B0%E0%AB%8B%E0%AA%95%E0%AA%BE%E0%AA%88%20%E0%AA%9C%E0%AA%BE.mp3",
  language: "Gujarati",
  },
  {
  id: "108",
  title: "제발 있어 주세요",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Please_Stayy/please%20stay%20Korean-%20%EC%A0%9C%EB%B0%9C%20%EC%9E%88%EC%96%B4%EC%A4%98.mp3",
  language: "Korean",
  },
  {
  id: "109",
  title: "कृपया थांब ना",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Please_Stayy/please%20stay%20Marathi%20-%20%E0%A4%A5%E0%A4%BE%E0%A4%82%E0%A4%AC%20%E0%A4%A8%E0%A4%BE.mp3",
  language: "Marathi",
  },
  {
  id: "110",
  title: "Por favor, fique",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Please_Stayy/please%20stay%20Portuguese-%20Por%20Favor%2C%20Fica.mp3",
  language: "Portuguese",
  },
  {
  id: "111",
  title: "Пожалуйста, останься",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Please_Stayy/please_stay_Russian_%D0%9F%D0%BE%D0%B6%D0%B0%D0%BB%D1%83%D0%B9%D1%81%D1%82%D0%B0%2C_%D0%BE%D1%81%D1%82%D0%B0%D0%BD%D1%8C%D1%81%D1%8F.mp3",
  language: "Russian",
  },
  {
  id: "112",
  title: "தயவுசெய்து இருங்கள்",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Please_Stayy/please%20stay%20Tamil%20-%20%E0%AE%A4%E0%AE%AF%E0%AE%B5%E0%AF%81%E0%AE%9A%E0%AF%86%E0%AE%AF%E0%AF%8D%E0%AE%A4%E0%AF%81%20%E0%AE%87%E0%AE%B0%E0%AF%81.mp3",
  language: "Tamil",
  },
  {
  id: "113",
  title: "Lütfen kal",
  url: "https://f003.backblazeb2.com/file/kingdom-games/Please_Stayy/please%20stay%20Turkish%20-%20L%C3%BCtfen%20Kal.mp3",
  language: "Turkish",
  },
  // i dont lose
  {
    id: "52",
    title: "I Dont Lose",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don't-Lose-all/0+I+Don't+Lose_english.MP3",
    language: "English",
  },
  {
    id: "53",
    title: "मैं ना हारूं",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_hindi.mp3",
    language: "Hindi",
  },
  {
    id: "54",
    title: "أنا لا أخسر",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_arabic.mp3",
    language: "Arabic",
  },
  {
    id: "55",
    title: "我不会输",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_mandarin%20chinese.mp3",
    language: "Chinese",
  },
  {
    id: "56",
    title: "Je ne perds pas",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_french.mp3",
    language: "French",
  },
  {
    id: "57",
    title: "Ich verliere nicht",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_german.mp3",
    language: "German",
  },
  {
    id: "58",
    title: "Non perdo",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_italian.mp3",
    language: "Italian",
  },
  {
    id: "59",
    title: "私は負けない",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_japanese.mp3",
    language: "Japanese",
  },
  {
    id: "60",
    title: "No pierdo",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_spanish.mp3",
    language: "Spanish",
  },
  {
    id: "61",
    title: "నేను ఓడిపోను",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/I-Don%27t-Lose-all/0%20I%20Don%27t%20Lose_telgu.mp3",
    language: "Telugu",
  },
  {
  id: "114",
  title: "હું હારતો નથી",
  url: "https://f003.backblazeb2.com/file/kingdom-games/i_dont_lose/i+dont+lose+Gujarati+-+%E0%AA%85%E0%AA%AE%E0%AB%87+%E0%AA%A8%E0%AA%A5%E0%AB%80+%E0%AA%B9%E0%AA%BE%E0%AA%B0%E0%AA%A4%E0%AA%BE.mp3",
  language: "Gujarati",
  },
  {
  id: "115",
  title: "난 절대 지지 않아",
  url: "https://f003.backblazeb2.com/file/kingdom-games/i_dont_lose/i%20dont%20lose%20Korean%20-%20%EC%9A%B0%EB%A6%AC%EB%8A%94%20%EC%A7%80%EC%A7%80%20%EC%95%8A%EC%95%84.mp3",
  language: "Korean",
  },
  {
  id: "116",
  title: "मी हरत नाही",
  url: "https://f003.backblazeb2.com/file/kingdom-games/i_dont_lose/i%20dont%20lose%20Marathi-%20%E0%A4%86%E0%A4%AE%E0%A5%8D%E0%A4%B9%E0%A5%80%20%E0%A4%95%E0%A4%A7%E0%A5%80%20%E0%A4%B9%E0%A4%B0%E0%A4%A4%20%E0%A4%A8%E0%A4%BE%E0%A4%B9%E0%A5%80.mp3",
  language: "Marathi",
  },
  {
  id: "117",
  title: "Eu não perco",
  url: "https://f003.backblazeb2.com/file/kingdom-games/i_dont_lose/i%20dont%20lose%20Portuguese%20-%20Nunca%20Vou%20Perder.mp3",
  language: "Portuguese",
  },
  {
  id: "118",
  title: "Я не проигрываю",
  url: "https://f003.backblazeb2.com/file/kingdom-games/i_dont_lose/i%20dont%20lose%20Russian%20-%20%D0%9C%D1%8B%20%D0%9D%D0%B5%20%D0%9F%D1%80%D0%BE%D0%B8%D0%B3%D1%80%D0%B0%D0%B5%D0%BC.mp3",
  language: "Russian",
  },
  {
  id: "119",
  title: "நான் தோற்பதில்லை",
  url: "https://f003.backblazeb2.com/file/kingdom-games/i_dont_lose/i%20dont%20lose%20Tamil%20-%20%E0%AE%A8%E0%AE%BE%E0%AE%AE%E0%AF%8D%20%E0%AE%A4%E0%AF%8B%E0%AE%B1%E0%AF%8D%E0%AE%95%20%E0%AE%AE%E0%AE%BE%E0%AE%9F%E0%AF%8D%E0%AE%9F%E0%AF%8B%E0%AE%AE%E0%AF%8D.mp3",
  language: "Tamil",
  },
  {
  id: "120",
  title: "Ben kaybetmem",
  url: "https://f003.backblazeb2.com/file/kingdom-games/i_dont_lose/i%20dont%20lose%20Turkish-%20Asla%20Kaybetmem.mp3",
  language: "Turkish",
  },
];


